var Load_More = {

	isLoading:false,

	init:function(){

		$(window).scroll(function(){
			Load_More.scroll();
		});
		Load_More.scroll();


		$(".form-load-more").on("submit", function(e){
			e.stopPropagation();
			e.preventDefault();

			Load_More.isLoading = true;
			
			$(".form-load-more").addClass("loading");

			
			var formData = new FormData(this);

			$.ajax({
				url: ajaxurl,
				type: 'POST',
				data: formData,
				success: function (data) {
					var _data = JSON.parse(data);
					Debug.log("AJAX COMPLETED -> " + _data.message);

					$(".all-articles").append(_data.result.html);
					var _current_page = parseInt($(".form-load-more input[name='page']").val());

					if(_data.result.max_pages <= _current_page){
						// DISPARITION BOUTON
						$(".form-load-more").addClass("hidden");
					}else{

						$(".form-load-more").removeClass("hidden");
						$(".form-load-more input[name='page']").val(_current_page + 1);	
					}

					Load_More.isLoading = false;

				},
				cache: false,
				contentType: false,
				processData: false
			});
			
		});
	},	
	scroll:function(){
		
		if(Load_More.isLoading == false){
			var _scroll_min = $(window).scrollTop() + ($(window).outerHeight());
			Debug.log("SCROLL: " + $(".form-load-more").offset().top + " -- " +_scroll_min);

			if(_scroll_min > $(".form-load-more").offset().top){
				if(!$(".form-load-more").hasClass("hidden")){
					$(".form-load-more").submit();
				}
			}
		}
		
	}
}

$(window).load(function(){
	if($(".form-load-more").length){
		Load_More.init();
	}
});
